import type { Locale } from '@avh/shared';

export const TIME_ZONE = 'Europe/Vienna';

function intlLocale(locale: Locale): string {
  return locale === 'de' ? 'de-AT' : 'en-GB';
}

export function formatDateTime(iso: string, locale: Locale = 'de'): string {
  const formatted = new Intl.DateTimeFormat(intlLocale(locale), {
    timeZone: TIME_ZONE,
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));
  return locale === 'de' ? `${formatted} Uhr` : formatted;
}

export function formatDate(iso: string, locale: Locale = 'de'): string {
  return new Intl.DateTimeFormat(intlLocale(locale), {
    timeZone: TIME_ZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(iso));
}

export function formatShortDateTime(iso: string, locale: Locale = 'de'): string {
  return new Intl.DateTimeFormat(intlLocale(locale), {
    timeZone: TIME_ZONE,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));
}

export function formatTime(iso: string, locale: Locale = 'de'): string {
  const formatted = new Intl.DateTimeFormat(intlLocale(locale), {
    timeZone: TIME_ZONE,
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(iso));
  return locale === 'de' ? `${formatted} Uhr` : formatted;
}

/** Kalenderblatt-Teile für Event-Karten: Tag, Monat (kurz). */
export function dateParts(iso: string, locale: Locale): { day: string; month: string } {
  const date = new Date(iso);
  return {
    day: new Intl.DateTimeFormat(intlLocale(locale), { timeZone: TIME_ZONE, day: 'numeric' }).format(date),
    month: new Intl.DateTimeFormat(intlLocale(locale), { timeZone: TIME_ZONE, month: 'short' }).format(date),
  };
}

export function groupsOfFour(value: string): string {
  return value.replace(/\s/g, '').replace(/(.{4})/g, '$1 ').trim();
}

export function localized(locale: Locale, german: string, english: string): string {
  return locale === 'en' && english.trim() !== '' ? english : german;
}

/** `<input type="datetime-local">` arbeitet in Ortszeit ohne Zone. */
export function isoToLocalInput(iso: string | null): string {
  if (!iso) {
    return '';
  }
  const date = new Date(iso);
  const offset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() - offset).toISOString().slice(0, 16);
}

export function localInputToIso(value: string): string | null {
  return value ? new Date(value).toISOString() : null;
}
